import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { EcommerceApplicationEventPayload } from '~shared/models';

export class GaTrackingViewCartEventModel {
  constructor(private viewCartApplicationEvent: EcommerceApplicationEventPayload) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ViewCart;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ...this.viewCartApplicationEvent,
      },
    };
  }
}
